import React, { useEffect, useState } from 'react';
import { StepContainer, NavigationButtons, InfoBox } from '../index';
import { useWizard } from '../../wizard';
import { contentApi } from '../../services/contentApi';
import { contentKeys } from '../../constants/contentKeys';

const DriverStartStep: React.FC = () => {
  const { goNext } = useWizard();
  const [title, setTitle] = useState("Ansøgning om kørekort");
  const [body, setBody] = useState<string[] | null>(null);
  useEffect(() => {
    contentApi.getByKey(contentKeys.koerekort.dl_start).then(c => {
      if (c?.title) {setTitle(c.title);}
      if (c?.body && c.body.length > 0) {setBody(c.body);}
    });
  }, []);
  return (
    <StepContainer title={title}>
      {body && <InfoBox type="info">{body.map((p,i) => <p key={i}>{p}</p>)}</InfoBox>}
      <NavigationButtons onNext={goNext} showBack={false} nextText="Start" />
    </StepContainer>
  );
};

export default DriverStartStep;


